import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import HomePage from "./pages/HomePage";
import PLP from './pages/PLP';
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import PDP from './pages/PDP';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Profile from './pages/Profile';
import OrderConfirmation from './pages/orderConfirmation';
import APITest from './pages/APITest';
import DirectAPITest from './pages/DirectAPITest';
import AdminProducts from './pages/AdminProducts';
import AdminFeedback from './pages/AdminFeedback';
import AdminWallet from './pages/AdminWallet';
import AdminInventory from './pages/AdminInventory';
import Wallet from './pages/Wallet';
import ContactFeedback from './pages/ContactFeedback';

import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';

import MainLayout from './components/MainLayout';

import './App.css';
import Signup from './pages/Signup';
import MyOrders from './pages/MyOrders';
import AdminOrders from './pages/AdminOrders';
import AdminTodoPage from './pages/AdminTodo';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <CssBaseline />

        <Routes>
          <Route element={<MainLayout />}>

            {/* PUBLIC ROUTES */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/shop" element={<PLP />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/api-test" element={<APITest />} />
            <Route path="/direct-api-test" element={<DirectAPITest />} />
            <Route
              path="/my-orders"
              element={
                <PrivateRoute>
                  <MyOrders />
                </PrivateRoute>
              }
            />
            <Route path="/contact-feedback" element={<ContactFeedback />} />

            {/* ✅ PDP SHOULD BE PUBLIC */}
            <Route path="/product/:id" element={<PDP />} />

            {/* ✅ CART SHOULD ALSO BE PUBLIC (recommended) */}
            <Route path="/cart" element={<Cart />} />

            {/* 🔒 ONLY CHECKOUT SHOULD BE PROTECTED */}
            <Route
              path="/checkout"
              element={
                <PrivateRoute>
                  <Checkout />
                </PrivateRoute>
              }
            />

            {/* 🔒 PROFILE */}
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />

            {/* 🔒 WALLET & REFERRAL */}
            <Route
              path="/wallet"
              element={
                <PrivateRoute>
                  <Wallet />
                </PrivateRoute>
              }
            />

            {/* 🔒 ADMIN */}
            <Route
              path="/admin/products"
              element={
                <AdminRoute>
                  <AdminProducts />
                </AdminRoute>
              }
            />
             <Route
              path="/admin/orders"
              element={
                <AdminRoute>
                  <AdminOrders />
                </AdminRoute>
              }
            />
             <Route
              path="/admin/feedback"
              element={
                <AdminRoute>
                  <AdminFeedback />
                </AdminRoute>
              }
            />
             <Route
              path="/admin/inventory"
              element={
                <AdminRoute>
                  <AdminInventory />
                </AdminRoute>
              }
            />
             <Route
              path="/admin/wallet"
              element={
                <AdminRoute>
                  <AdminWallet />
                </AdminRoute>
              }
            />
             <Route
              path="/admin/tasks"
              element={
                <AdminRoute>
                  <AdminTodoPage />
                </AdminRoute>
              }
            />
            {/* 🔒 ORDER CONFIRMATION */}
            <Route
              path="/order-confirmation/:id"
              element={
                <PrivateRoute>
                  <OrderConfirmation />
                </PrivateRoute>
              }
            />

          </Route>
        </Routes>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
